import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.header`
	background-color: ${helpers.color.pageHeaderBackground};
	box-shadow: inset 0 -1px 0 ${helpers.color.primaryTranslucent};
	grid-area: header;
	height: 60px;
	width: 100%;
	z-index: 1;
`
